import React from 'react';
import PropTypes from 'prop-types';

const ChairsNot = ({ color = '#BCC6CA', lineColor = '#fff', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="m11.942 22 .007-5.455" />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M17.318 14.727h1.79V9.272m-1.79 6.364a.9.9 0 0 1-.894.91h-8.95a.902.902 0 0 1-.894-.91v-1.363c0-.501.4-.91.895-.91 3.082-.605 6.065-.605 8.949 0 .495 0 .894.409.894.91v1.364Zm0-6.364h3.58c0-1-.805-1.817-1.79-1.817-.984 0-1.79.818-1.79 1.817Z"
    />
    <path
      stroke={color}
      strokeLinejoin="round"
      d="M6.58 14.727H4.79V9.272m10.739 3.925V3.818c0-1.004-.802-1.818-1.79-1.818h-3.58c-.988 0-1.79.814-1.79 1.818v9.386M6.58 9.272H3c0-1 .806-1.817 1.79-1.817s1.79.818 1.79 1.817Z"
    />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M5.685 22H18.2" />
    <path stroke={color} strokeLinejoin="round" d="M8.37 4.727h7.159" />
    <rect
      width={1.5}
      height={28.638}
      x={1.354}
      y={2.414}
      fill={color}
      stroke={lineColor}
      strokeWidth={0.5}
      rx={0.75}
      transform="rotate(-45 1.354 2.414)"
    />
  </svg>
);

ChairsNot.propTypes = {
  color: PropTypes.string,
  lineColor: PropTypes.string
};

export default ChairsNot;
